import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MortalityResults = _resolveComponent("MortalityResults")!

  return (_ctx.AnalysisLoading === 'done')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MortalityResults, {
          householdProps: _ctx.Household,
          mortalityStats: _ctx.MortalityAnalysis,
          ageTally: _ctx.MortalityAnalysis.ageTally,
          clusterTally: _ctx.MortalityAnalysis.clusterTally,
          deathRates: _ctx.MortalityAnalysis.deathRates,
          mortalityData: [],
          causeOfDeathStats: _ctx.MortalityAnalysis.causeOfDeath,
          locationStats: _ctx.MortalityAnalysis.location,
          fetchingData: _ctx.AnalysisLoading === 'loading',
          mortaltyAnalysisNotEnoughData: _ctx.AnalysisLoading === 'cancelled'
        }, null, 8, ["householdProps", "mortalityStats", "ageTally", "clusterTally", "deathRates", "causeOfDeathStats", "locationStats", "fetchingData", "mortaltyAnalysisNotEnoughData"])
      ]))
    : _createCommentVNode("", true)
}